<!-- 退款申请 --> 
<template>
	<div class="wrap">

		<Header backgroundColor="#F2F2F2"></Header>

		<Subheader
			title=""
			:hide="true"
			:hide2="true"
			:hideAlert="true"
			:hideStep="true"
			:stepNum="orderInfo.refund_state == 0 || refundInfo.status == 5 || reset == 1 ? 1 : (refundInfo.status == 1 && refundInfo.refund_type == 2 && !refundInfo.express_info ? 3 : 2)"
			style="z-index: 999999">
		</Subheader>

		<div class="box">
			<div class="box-leftsidebar">
				<!-- 未申请 -->
				<div class="return-reason" v-if="orderInfo.refund_state == 0 || reset == 1">
					<div class="row-start">
						<label class="row-label">退款商品:</label>
						<div class="row-sidebar" v-for="(goods, index) in orderInfo.order_item" :key="index">
							<img :src="goods.cover" class="product-img">
							<div class="product-sidebar">
								<p class="product-name">{{goods.name}}</p>
								<p class="product-msg" v-for="(item2, index2) in goods.goods_spec_arr" :key="index2">{{item2[0]}}：{{item2[1]}}</p>
							</div>
						</div>
					</div>
					<!-- <div class="row-start">
						<label class="row-label">服务类型:<span class="red-color">*</span></label>
						<div class="row-sidebar">
							<div class="radio-box">
								<label class="radio-item">
									<input style="display: none" v-model="type" value="1" id="type1" type="radio">
									<img :src="type=='1'? require('../../assets/circle2-active.png') : require('../../assets/circle-2.png')"
										class="radio-circle">
									仅退款
								</label>
								<label class="radio-item">
									<input style="display: none" v-model="type" value="2" id="type2" type="radio">
									<img :src="type=='2'? require('../../assets/circle2-active.png') : require('../../assets/circle-2.png')"
										class="radio-circle">
									退货退款
								</label>
							</div>
						</div>
					</div> -->
					<div class="row-start">
						<label class="row-label">退款原因:<span class="red-color">*</span></label>
						<div class="row-sidebar">
							<div style="min-width: 200px;display: flex;align-items: center;">
								<el-select v-model="params.apply_case" placeholder="请选择">
									<el-option v-for="(item, index) in refundCase" :key="index" :label="item.title"
										:value="item.title">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>
					<div class="row-start">
						<label class="row-label">退款金额:<span class="red-color">*</span></label>
						<div class="row-sidebar" style="flex-direction: column;align-items: flex-start;">
							<div style="min-width: 200px;display: flex;align-items: center;">
								<!-- <el-input v-model="input" placeholder="请输入金额"></el-input> -->
								￥{{orderInfo.price_total}}
							</div>
							<!-- <p class="font-1">最多￥25.9,含发货邮费￥0.00</p> -->
							<p class="font-1">
								<span>不可修改,最多￥{{orderInfo.price_total}}</span>
								<span v-if="orderInfo.price_express">，含发货邮费￥{{orderInfo.price_express}}</span>
								<span v-if="orderInfo.integral">，其中包含积分{{orderInfo.integral}}</span>
							</p>
						</div>
					</div>
					<!-- <div class="row-start">
						<label class="row-label">退款说明:</label>
						<div class="row-sidebar">
							<div style="min-width: 263px;display: flex;align-items: center;">
								<el-input maxlength="200" show-word-limit type="textarea" placeholder="请输入"
									v-model="desc">
								</el-input>
							</div>
						</div>
					</div> -->
					<div class="row-start">
						<label class="row-label">上传图片:</label>
						<div class="row-sidebar">
							<div class="upload-row">
								<div class="upload-item"  v-for="(item3, index3) in params.images" :key="index3">
									<img :src="item3" class="img">
									<img src="../../assets/del-img.png" class="close-icon" @click="del(index3)">
								</div>
								<el-upload class="add-box" :action="uploadURL" :show-file-list="false"
									:on-success="uploadimg" v-if="params.images.length < 3">
									<img src="../../assets/add-4.png" class="add-img">
								</el-upload>
							</div>
						</div>
					</div>
					<div class="btn-box">
						<button type="button" @click="orderRefund()">提交</button>
					</div>
				</div>
				
				<!-- 待审核 -->
				<div class="seller-processes-refund-application" v-if="orderInfo.refund_state != 0 && reset == 0">
					<div class="refund-application-top">
						<div class="top-row">
							<span class="top-row-msg" v-if="refundInfo.status == 0">请等待商家处理</span>
							<!-- 商家拒绝退款申请显示 -->
							<span class="top-row-msg" v-if="refundInfo.status == 2">商家拒绝了你的申请</span>
							<!-- 买家退货显示 -->
							<span class="top-row-msg" v-if="refundInfo.status == 1 && refundInfo.refund_type == 2 && !refundInfo.express_info">请退货并填写物流信息</span>
							<!-- 退款成功显示 -->
							<span class="top-row-msg red" v-if="refundInfo.status == 3">退款成功</span>
							<span class="top-row-msg red" v-if="refundInfo.status == 4">退款失败</span>
							<span class="top-row-msg red" v-if="refundInfo.status == 5">取消申请</span>
							<!-- <span class="countdown">还剩:1天23时42分</span> -->
						</div>
						<p class="refund-application-msg" v-if="refundInfo.status == 0">您已成功发起退款，请耐心等待商家处理</p>
						<!-- 商家拒绝退款申请显示 -->
						<p class="refund-application-msg" v-if="refundInfo.status == 2">进行重新退款</p>
						<!-- 买家退货显示 -->
						<p class="refund-application-msg" v-if="refundInfo.status == 1 && refundInfo.refund_type == 2 && !refundInfo.express_info">
							商家已同意退货申请,请尽早发货
						</p>
						<!-- 退款成功显示 -->
						<p class="refund-application-msg" v-if="refundInfo.status == 3">将退还你的支付账户</p>
					</div>
					<div class="refund-application-center">
						<!-- 商家拒绝退款申请显示 -->
						<p class="font-1" v-if="refundInfo.status == 2">进行重新退款</p>
						<!-- 买家退货显示 -->
						<!-- <p class="font-1">退货地址</p> -->
						<!-- 退款成功显示 -->
						<!-- <p class="font-1">退货地址</p> -->
						<ul class="center-list">
							<li>商家同意或者超时未处理申请，系统将会退款给你</li>
							<li>如果商家拒绝，您可以修改退款申请后再次发起，商家会重新处理</li>
						</ul>
						<div class="center-btnBox">
							<!-- <button type="button" class="bg-btn">修改申请</button> -->
							<button type="button" class="border-btn" v-if="refundInfo.status == 0" @click="cancelApply()">撤销申请</button>
							<!-- 商家拒绝退款申请显示 -->
							<button type="button" class="border-btn" v-if="refundInfo.status == 2" @click="resetRefund()">再次申请</button>
							<button type="button" class="border-btn" v-if="refundInfo.status == 5" @click="resetRefund()">再次申请</button>
							<!-- 买家退货显示 -->
							<button
								type="button"
								class="bg-btn"
								v-if="refundInfo.status == 1 && refundInfo.refund_type == 2 && !refundInfo.express_info"
								@click="addExpress = true"
							>
								我已寄出
								<span>（点击填写物流单号）</span>
							</button>
							<button
								type="button"
								class="border-btn"
								v-if="refundInfo.status == 1 && refundInfo.refund_type == 2 && !refundInfo.express_info"
								@click="cancelApply()"
							>
								撤销申请
							</button>
						</div>
					</div>
					<div class="refund-application-bottom">
						<p class="bottom-label">协商历史</p>
						<div class="bottom-msgBox">
							<p>退款类型: 退货退款</p>
							<p>退款金额: ￥{{orderInfo.price_total}}</p>
							<p>退款原因: {{refundInfo.apply_case}}</p>
							<!-- <p>退款描述: 发票问题</p> -->
						</div>
					</div>
				</div>

				<div class="write-refund-logistics-number" v-if="refundInfo.status == 1 && refundInfo.refund_type == 2 && !refundInfo.express_info">
					<div class="write-top">
						<div class="top-row">
							<span class="top-row-msg">退货地址</span>
						</div>
						<!-- <div class="address-box">
							<p>收货人:上海孩子王品牌旗舰店 0563-6988538</p>
							<p>安徽省宣城市广德县经济开发区建设北路安徽孩子王有限公司</p>
						</div> -->
					</div>
					<div class="write-center">
						<div class="row-start">
							<label class="row-label">物流公司:<span class="red-color">*</span></label>
							<div class="row-sidebar" style="flex-direction: column;align-items: flex-start;">
								<div style="min-width: 200px;display: flex;align-items: center;">
									<el-input v-model="refundExpressParams.express_name" placeholder="请填写物流公司"></el-input>
								</div>
							</div>
						</div>
						<div class="row-start">
							<label class="row-label">物流单号:<span class="red-color">*</span></label>
							<div class="row-sidebar" style="flex-direction: column;align-items: flex-start;">
								<div style="min-width: 200px;display: flex;align-items: center;">
									<el-input v-model="refundExpressParams.express_no" placeholder="请填写物流单号"></el-input>
								</div>
							</div>
						</div>
						<div class="write-btnBox">
							<button type="button" class="bg-btn" @click="refundExpress()">提交</button>
						</div>
					</div>
					<div class="write-bottom">
						<p class="bottom-label">协商历史</p>
						<div class="bottom-msgBox">
							<p>退款类型: 退货退款</p>
							<p>退款金额: ￥{{orderInfo.price_total}}</p>
							<p>退款原因: {{refundInfo.apply_case}}</p>
							<!-- <p>退款描述: 发票问题</p> -->
						</div>
					</div>
				</div>
			</div>
			<div class="box-rightsidebar">
				<div class="order-module">
					<p class="order-module-label">订单详情</p>
					<div class="row-sidebar" v-for="(goods, index) in orderInfo.order_item" :key="index">
						<img :src="goods.cover" class="product-img">
						<div class="product-sidebar">
							<p class="product-name-small">{{goods.name}}</p>
							<p class="product-msg" v-for="(item2, index2) in goods.goods_spec_arr" :key="index2">{{item2[0]}}：{{item2[1]}}</p>
						</div>
					</div>
				</div>
				<div class="order-msg-module">
					<p class="order-msg-row">
						<span class="order-msg-label">订单编号:</span>
						<span class="font-2">{{orderInfo.order_no}}</span>
					</p>
					<!-- <p class="order-msg-row">
						<span class="order-msg-label">单 价:</span>
						<span class="font-3">￥54.00*1(数量)</span>
					</p> -->
					<p class="order-msg-row">
						<span class="order-msg-label">商品总价:</span>
						<span class="font-3">￥{{orderInfo.price_goods}}</span>
					</p>
					<p class="order-msg-row">
						<span class="order-msg-label">运 费:</span>
						<span class="font-3">￥{{orderInfo.price_express}}</span>
					</p>
					<p class="order-msg-row">
						<span class="order-msg-label">实付款:</span>
						<span class="font-3">￥{{orderInfo.price_total}}</span>
					</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	import Subheader from '../../components/sub-header.vue';
	import { orderCancelApply, orderGetOrderDetail, orderGetRefundCase, orderGetRefundInfo, orderOrderRefund, orderRefundExpress } from '../../service/service';
	import {
		uploadURL
	} from '../../service/request';
	import { validatorFun } from '../../utils/util';
	export default {
		components: {
			Header,
			Subheader
		},
		data() {
			return {
				uploadURL,
				type: 1,
				options: [{
					value: '选项1',
					label: '发票问题'
				}, {
					value: '选项2',
					label: '卖家发错货'
				}, {
					value: '选项3',
					label: '退运费'
				}, {
					value: '选项4',
					label: '商品描述与实物不符'
				}, {
					value: '选项5',
					label: '商品描述材质与实物不符'
				}, {
					value: '选项6',
					label: '做工问题'
				}, {
					value: '选项7',
					label: '少件/漏发'
				}],
				value: '',
				input: '',
				desc: '',
				imageSrc: '', // 图片地址
				status: 1,

				reset: 0, // 0 根据退款订单状态 1 重新申请

				// 退款原因
				refundCase: [],
				refundCaseIndex: -1,

				// 订单详情
				orderInfo: {
					id: 0
				},
				// 退款申请参数
				params: {
					order_id: 0,  // 订单id
					apply_case: '',  // 退款原因
					images: [],  // 图片
				},

				// 退款单详情
				refundInfo: {},
				
				// 物流提交参数
				refundExpressParams:{
					id: '',  // 退款记录id
					express_address: '',  // 退货地址
					express_user: '',  // 收件人
					express_tel: '',  // 电话
					express_name: '',  // 物流公司名称（退货的物流公司是用户自己填写的，，，想用哪个用哪个）
					express_no: '',  // 快递号
				},

				addExpress: false,
			};
		},
		mounted() {
			const option = this.$route.query;
			const id =  parseInt(option.id || 0);
			const reset = parseInt(option.reset || 0);
			this.reset = reset;
			if (id > 0) {
				this.orderInfo.id = id;
				this.params.order_id = id;
				this.init();
			}
		},
		methods: {
			init() {
				this.getOrderDetail();
				this.getRefundCase();
			},
			resetRefund() {
				this.$router.push(`/my/refund-application?id=${this.orderInfo.id}&reset=1`);
				this.reset = 1;
				this.init();
			},
			// 取消退款
			cancelApply() {
				this.$confirm('确认取消退款？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					orderCancelApply({id: this.refundInfo.id}).then(({code, msg, data}) => {
						if (code == 1) {
							this.init();
							this.$message.success(msg);
						} else {
							this.$message.error(msg);
						}
					});
				});
			},
			// 提交物流
			refundExpress() {
				const params = this.refundExpressParams;
				const errList = validatorFun(params, [
					['express_name', ['notNull', `请填写物流公司`]],
					['express_no', ['notNull', `请填写物流单号`]],
				]);
				if (errList.length > 0) {
					return this.$message.warning(errList[0].errMsg);
				}
				orderRefundExpress(params).then(({code, msg, data}) => {
					if (code == 1) {
						this.init();
						this.$message.success(msg);
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取退款详情
			getRefundInfo() {
				orderGetRefundInfo({ order_id: this.orderInfo.id }).then(({code, msg, data}) => {
					if (code == 1) {
						this.refundInfo = data.detail;
						this.refundExpressParams.id = data.detail.id;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 提交申请
			orderRefund() {
				const params = {...this.params, images: this.params.images.join('|')};
				const errList = validatorFun(params, [
					['apply_case', ['notNull', `请选择退款原因`]],
					['images', ['notNull', `请上传凭证图片`]],
				]);
				if (errList.length > 0) {
					return this.$message.warning(errList[0].errMsg);
				}
				orderOrderRefund(params).then(({code, msg, data}) => {
					if (code > 0) {
						setTimeout(() => {
							this.init();
						}, 1000);
						this.$message.success(msg);
					} else {
						this.$message.error(msg);
					}
				});
			},
			uploadimg({data}) {
				this.params.images.push(data);
			},
			//删除图片
			del(index) {
				this.params.images.splice(index, 1)
			},
			// 订单详情
			getOrderDetail() {
				orderGetOrderDetail({ order_id: this.orderInfo.id }).then(({ code, msg, data }) => {
					if (code == 1) {
						data.detail.order_item = data.detail.order_item.map(item => ({
							...item,
							['goods_spec_arr']: item.goods_spec.split(';;').map(str => str.split('::')),
						})),
						this.orderInfo = data.detail;
						if (this.orderInfo.refund_state > 0) {
							this.getRefundInfo();
						}
					} else {
						this.$message.error(msg);
					}
				});
			},
			
			// 获取退款原因
			getRefundCase() {
				orderGetRefundCase().then(({code, data, msg}) => {
					if (code == 1) {
						this.refundCase = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},
			test: function() {
				const file = this.$refs.fileInput.files[0]
				const fileReader = new FileReader()
				fileReader.onload = (temp) => {
					this.imageSrc = temp.target.result
				}
				fileReader.readAsDataURL(file)
			},
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		margin: 140px 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.box {
		width: 1200px;
		display: flex;
		align-items: center;
		margin: 21px 0 39px;
	}

	.box-leftsidebar {
		flex: 1;
		height: 809px;
		overflow: auto;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-right: 19px;
	}

	.return-reason {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 27px 28px;
		box-sizing: border-box;
	}

	.row-start {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
	}

	.row-label {
		width: 73px;
		line-height: 21px;
		color: #000000;
		font-size: 12px;
	}

	.row-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.product-img {
		width: 99px;
		height: 99px;
		border-radius: 6px;
		margin-right: 13px;
		object-fit: cover;
	}

	.product-sidebar {
		width: 574px;
		height: 99px;
		display: flex;
		flex-direction: column;
	}

	.product-name {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #000000;
		font-size: 16px;
		margin-bottom: 8px;
	}

	.product-name-small {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #000000;
		font-size: 12px;
		margin-bottom: 8px;
	}

	.product-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #666666;
		font-size: 12px;
	}

	.red-color {
		color: #F91F1D;
	}

	.box-rightsidebar {
		width: 355px;
		height: 809px;
		background-color: #FFFFFF;
		border-radius: 8px;
		overflow: auto;
		padding: 22px 17px;
		box-sizing: border-box;
	}

	.radio-box {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.radio-item {
		width: 100%;
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #000000;
		margin-bottom: 10px;
	}

	.radio-item:last-child {
		margin-bottom: 0;
	}

	.radio-circle {
		width: 14px;
		height: 14px;
		margin-right: 12px;
	}

	.font-1 {
		color: #BBBBBB;
		font-size: 12px;
		margin-top: 9px;
	}

	>>>.el-input__inner {
		height: 21px !important;
		line-height: 21px !important;
		border: 1px solid #BBBBBB !important;
		color: #111111;
		font-size: 12px !important;
		padding: 0 14px !important;
	}

	.upload-row {
		flex: 1;
		display: flex;
		flex-wrap: wrap;
	}

	.add-img {
		width: 96px;
		height: 96px;
		border-radius: 4px;
	}

	.img {
		width: 96px;
		height: 96px;
		object-fit: cover;
		border-radius: 4px;
	}

	.upload-item {
		width: 96px;
		height: 96px;
		margin-right: 10px;
		margin-bottom: 10px;
		position: relative;
	}

	.close-icon {
		position: absolute;
		right: 9px;
		top: 9px;
		z-index: 999;
		width: 11px;
		height: 11px;
	}

	.add-box {
		width: 96px;
		height: 96px;
		position: relative;
		overflow: hidden;
	}

	.upload-btn {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1000;
		width: 96px;
		height: 96px;
		opacity: 0;
		cursor: pointer;
		border: 1px solid;
	}

	.add-img {
		width: 96px;
		height: 96px;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 100;
	}

	.btn-box {
		width: 100%;
		padding-left: 73px;
		box-sizing: border-box;
	}

	.btn-box>button {
		width: 214px;
		height: 50px;
		line-height: 50px;
		background-color: #F2501A;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 16px;
	}

	.order-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 60px;
	}

	.order-module-label {
		width: 100%;
		color: #000000;
		font-size: 12px;
		margin-bottom: 9px;
	}

	.order-msg-module {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.order-msg-row {
		width: 100%;
		display: flex;
		align-items: center;
		font-size: 12px;
		margin-bottom: 10px;
	}

	.order-msg-row:last-child {
		margin-bottom: 0;
	}

	.order-msg-label {
		color: #BBBBBB;
		min-width: 60px;
		display: block;
	}

	.font-2 {
		color: #F2501A;
	}

	.font-3 {
		color: #000000;
	}

	>>>.el-input__icon {
		line-height: 21px !important;
	}

	>>>.el-textarea__inner {
		height: 117px !important;
		border: 1px solid #BBBBBB !important;
		color: #111111;
		font-size: 12px;
	}

	.seller-processes-refund-application {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.refund-application-top {
		width: 100%;
		height: 135px;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		border-bottom: 1px solid #F6F6F6;
	}

	.top-row {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 24px;
	}

	.top-row-msg {
		color: #000000;
		font-size: 19px;
	}

	.top-row-msg.red {
		color: #F2501A;
	}

	.countdown {
		color: #FF3C24;
		font-size: 13px;
		margin-left: 36px;
	}

	.refund-application-msg {
		width: 100%;
		color: #BBBBBB;
		font-size: 15px;
	}

	.refund-application-center {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 22px 20px 56px;
		box-sizing: border-box;
		border-bottom: 1px solid #F6F6F6;
	}

	.center-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.center-list>li {
		width: 100%;
		color: #BBBBBB;
		font-size: 15px;
		padding-left: 14px;
		box-sizing: border-box;
		position: relative;
	}

	.center-list>li::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		background-color: #BBBBBB;
		width: 5px;
		height: 5px;
		border-radius: 50%;
	}

	.center-btnBox {
		width: 100%;
		display: flex;
		padding-left: 37px;
		box-sizing: border-box;
		align-items: center;
		margin-top: 50px;
	}

	.center-btnBox>button,
	.write-btnBox>button {
		width: 214px;
		height: 50px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 15px;
		border-radius: 8px;
		margin-right: 19px;
	}

	.center-btnBox>button>span,
	.write-btnBox>button>span {
		color: #FFFFFF;
		font-size: 8px;
	}

	.center-btnBox>button:last-child,
	.write-btnBox>button:last-child {
		margin-right: 0;
	}

	.center-btnBox>button.bg-btn,
	.write-btnBox>button.bg-btn {
		background-color: #F2501A;
		color: #fff;
	}

	.center-btnBox>button.border-btn,
	.write-btnBox>button.border-btn {
		border: 1px solid #E63D23;
		background-color: #FFFFFF;
		color: #F2501A;
	}

	.refund-application-bottom,
	.write-bottom {
		width: 100%;
		padding: 34px 22px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.bottom-label {
		width: 100%;
		margin-bottom: 17px;
		font-size: 15px;
		color: #434849;
	}

	.bottom-msgBox {
		width: 100%;
		display: flex;
		flex-direction: column;
		color: #434849;
		font-size: 20px;
		padding-left: 19px;
		box-sizing: border-box;
	}

	.bottom-msgBox>p {
		margin-bottom: 3px;
	}

	.font-1 {
		width: 100%;
		color: #434849;
		font-size: 17px;
		margin-bottom: 5px;
	}

	.write-top {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 24px 22px 39px;
		border-bottom: 1px solid #F6F6F6;
		box-sizing: border-box;
	}

	.write-center {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 15px 37px 63px;
		box-sizing: border-box;
		border-bottom: 1px solid #F6F6F6;
	}

	.write-btnBox {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 37px;
	}

	.address-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		color: #BBBBBB;
		font-size: 16px;
		padding-left: 26px;
		box-sizing: border-box;
	}

	.address-box>p {
		margin-bottom: 13px;
	}

	.address-box>p:last-child {
		margin-bottom: 0;
	}
</style>
